import { DiagramShape } from '@/components/diagrams/components/DiagramShape/DiagramShape';
import { TILE_DEFAULT_VARIANT } from '@/components/diagrams/components/Tile/constants';
import {
  type DiagramNodeFill,
  GraphVizIconShape,
} from '@/components/diagrams/diagramStyle';
import { type TileNodeProps } from '@/components/diagrams/FlowChart/nodes/TileNode/TileNode';

import { useDiagramTextFields } from '../../hooks/useDiagramTextFields';
import { type ReactFlowDiagramNodeData } from '../../utils/reactFlowDiagram';
import { DiagramNodeFrame } from './DiagramNodeFrame';

/** A shape shows only its title. */
const SHAPE_TEXT_FIELDS = ['label'] as const;

/**
 * A builder node with the SHAPE display: its title inside its shape. The
 * user edits the title in place with a double-click, and resizes the shape
 * without changing its proportions.
 */
export function DiagramShapeNode(props: TileNodeProps) {
  const { data, selected, width } = props;
  const {
    item,
    variant = TILE_DEFAULT_VARIANT,
    customColor,
    iconShape = GraphVizIconShape.Rounded,
  } = data as ReactFlowDiagramNodeData;
  const { renderField, onDoubleClick } = useDiagramTextFields(
    props,
    SHAPE_TEXT_FIELDS
  );
  return (
    <DiagramNodeFrame {...props} keepAspectRatio>
      <DiagramShape
        shape={iconShape}
        fill={item.nodeStyle?.fill as DiagramNodeFill | null | undefined}
        variant={variant}
        customColor={customColor}
        width={width ?? 0}
        isSelected={!!selected}
        onDoubleClick={onDoubleClick}
        label={renderField('label')}
      />
    </DiagramNodeFrame>
  );
}
